







































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Company from "../../../store/entities/company";
import aMapCreate from "./amap.vue";
@Component({
  components: { aMapCreate },
})
export default class CreateCompany extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  company: Company = new Company();
  idisable:boolean = false;
  createmap: string = "creatmap";
  aMapCreateModalShow: boolean = false;
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  openAmap() {
    this.aMapCreateModalShow = true;
  }
  mapaddr(longitude, latitude) {
    //console.log(longitude+latitude);
    this.company["longitude"] = longitude;
    this.company["latitude"] = latitude;
  }
  typelist=[
                {
                    value: 0,
                    label: '温湿度'
                },
                {
                    value: 1,
                    label: '烟虫'
                },
                {
                    value: 2,
                    label: '水分'
                },
                {
                    value: 3,
                    label: '温湿度加烟虫'
                },
                {
                    value: 4,
                    label: '温湿度加水分'
                }
            ]
  save() {
    (this.$refs.companyForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true;
        await this.$store.dispatch({
          type: "company/create",
          data: this.company,
        });
        (this.$refs.companyForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel() {
    (this.$refs.companyForm as any).resetFields();
    this.$emit("input", false);
  }
  companyRule = {
    cName: [{ required: true, message: "请填写企业名称", trigger: "blur" }],
    addr: [{ required: true, message: "请填写企业地址", trigger: "blur" }],
    cPhone: [{ required: true, message: "请填写企业电话", trigger: "blur" }],
    linkName: [{ required: true, message: "请填写联系人", trigger: "blur" }],
    linkMobile: [{ required: true, message: "请填写联系人电话", trigger: "blur" }],
    type: [{type: "number",required: true,message: "请选择安装的设备",trigger: "change"}],
  };
}
